// extracted by mini-css-extract-plugin
module.exports = {"CartAddedSummary":"CartAddedSummary_CartAddedSummary__3rnhV","LinkSummary":"CartAddedSummary_LinkSummary__C2nEJ","CloseButton":"CartAddedSummary_CloseButton__2ZO4e"};